/* eslint camelcase: 0 */
import { MonitaroGatewayBase } from './base'
import { toAppointmentProps } from './translator/appointment'
import { toQuery, toQueryProps } from './translator/query'
import { EmptyResponsePropsFactory } from '@/entities/Response'
import { IQueryProps } from '@/entities/Query'
import { FetchSchedule, GetSchedule } from '@/infrastructure/network/Monitaro/requests/schedule'

export default class Schedule extends MonitaroGatewayBase {
  async FetchSchedule(query?: IQueryProps) {
    const response = await this.apiClient.request(new FetchSchedule(toQuery(query)))
    return EmptyResponsePropsFactory({
      items: response.appointments.map((prop) => toAppointmentProps(prop)),
      query: toQueryProps(response.query)
    })
  }

  async GetSchedule(schedule: string) {
    const { appointment } = await this.apiClient.request(new GetSchedule(schedule))
    return toAppointmentProps(appointment)
  }
}
